/**
 * InputLabelOverride adjusts the InputLabel font size
 * as well as the notch width on the boarder of the
 * select menu
 */
export const InputLabelOverride = {
  MuiInputLabel: {
    styleOverrides: {
      outlined: {
        '&.MuiInputLabel-shrink': {
          fontSize: '19px', //InputLabel Font Size
        },
      },
    },
  },

  MuiOutlinedInput: {
    styleOverrides: {
      notchedOutline: {
        fontSize: '19px', //InputLabel Notch Width
      },
    },
  },
}
